"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const InputSlider = (props) => {
    const [newCurrent, setNewCurrent] = react_1.useState(props.current);
    react_1.useEffect(() => setNewCurrent(props.current), [props.current]);
    const onRangeMouseUp = () => {
        props.onChangeEnd(newCurrent);
    };
    const onRangeChanged = (e) => {
        setNewCurrent(e.target.value);
        props.onChange(e.target.value);
    };
    return React.createElement("input", { onMouseDown: props.onChangeStart, onMouseUp: onRangeMouseUp, onChange: onRangeChanged, type: "range", min: "0", max: props.total, step: 0.01, value: newCurrent });
};
exports.default = InputSlider;
//# sourceMappingURL=InputSlider.js.map